export default "__VITE_ASSET__Cs5Oi0yM__"